import { planLimitsTypes } from './actionTypes'
import { PlanLimitsPopupActions, PlanLimitsState } from './types'

const initialState: PlanLimitsState = {
    isVisible: false,
}

export default (state = initialState, action: PlanLimitsPopupActions) => {
    switch (action.type) {
        case planLimitsTypes.SHOW_PLAN_LIMITS_POPUP:
            return {
                ...state,
                isVisible: true,
            }
        case planLimitsTypes.HIDE_PLAN_LIMITS_POPUP:
            return initialState
        default:
            return {
                ...state,
            }
    }
}
